import {LabelPicker, type LabelPickerProps} from '@github-ui/item-picker-label-tsq'

import {usePreloadedLabels} from './use-preloaded-labels'

/**
 * Relay wrapper for TSQ Label Picker with preloaded data support.
 *
 * This wrapper bridges Relay GraphQL data fetching with the TSQ (TanStack Query) Label Picker.
 * It fetches label data using Relay's useClientQuery and transforms it into the format
 * expected by the TSQ component's `preloadedLabels` prop.
 *
 * The transformation converts Relay's GraphQL response into a plain object structure
 * that TSQ can consume without requiring Relay fragment processing.
 */
export function LabelPickerTsqWithRelayWrapper(props: LabelPickerProps) {
  const preloadedLabels = usePreloadedLabels(props.owner, props.repo)
  return <LabelPicker {...props} preloadedLabels={preloadedLabels} />
}

try{ LabelPickerTsqWithRelayWrapper.displayName ||= 'LabelPickerTsqWithRelayWrapper' } catch {}